module.exports = ".m-bottom {\n    margin-bottom: 5px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/gto-dashboard/buscar-gto/buscar-gto.component.css
// module id = ./src/app/components/dashboard/gto-dashboard/buscar-gto/buscar-gto.component.css
// module chunks = main